import { useDispatch } from 'react-redux';
import { useCreateAgentStatusChangeMutation } from 'services';
import { AgentStatusChangeDto } from 'types';

export function useAgentStatusChange() {
  const dispatch = useDispatch();

  const [createAgentStatusChange, { isLoading, error }] = useCreateAgentStatusChangeMutation();

  const onCreateAgentStatusChangeHandle = async (values: AgentStatusChangeDto) => {
    try {
      // Skip if no valid previous state
      if (!values.previousState || values.previousState === 'UNKNOWN') {
        // console.log('Skipping agent status change - no valid previous state');
        return;
      }

      // Ensure extensionId is string
      const payload: AgentStatusChangeDto = {
        ...values,
        extensionId: values.extensionId,
        previousState: values.previousState
      };

      await createAgentStatusChange(payload)
        .unwrap()
        .then((res) => {
          // console.log('Agent status change created successfully:', res);
        })
        .catch((err) => {
          // console.error('Failed to create agent status change:', err);
          throw err;
        });
    } catch (err) {
      // console.error('Error in onCreateAgentStatusChangeHandle:', err);
      throw err;
    }
  };

  return {
    isLoading,
    error,
    onCreateAgentStatusChangeHandle
  };
}
